// removed by extract-text-webpack-plugin
module.exports = {"catalog_item":"index_QC5p9zA"};


//////////////////
// WEBPACK FOOTER
// ./src/component/catalog/index.css
// module id = 948
// module chunks = 0